import { useMutation } from 'react-query';
import { markReadNotification } from 'api/notification';

export const useReadNotification = () => {
  return useMutation<void, Error, string[]>(async (ids) => {
    await markReadNotification(ids);
  });
};
